<template>
    <div>
        <Modal
                width="440"
                class="monitor_bag"
                v-model="modalState"
                :footer-hide="true"
                @on-cancel="clickCancel"
        >
            <div slot="header" class="header_group">
                <h1 class="header_title">购买加油包</h1>
                <p class="header_desc">您套餐内的次数使用完毕，可选择加油包或再次充值会员服务包</p>
            </div>
            <div class="monitor_bag_main">
                <h3 class="main_title">选择服务</h3>

                <Select class="monitor_bag_select" v-model="bagSelection" :on-change="setNowData(bagSelection)">
                    <Option :value="item.code" v-for="(item,index) in selectData">{{ item.title }}</Option>
                </Select>

                <p class="main_money">¥{{bagMoney}}</p>
                <div class="main_btn_group">
                    <div @click="OpeningBtn" class="main_btn">购买加油包</div>
                    <div @click="renewBtn" class="main_btn">会员续费</div>
                </div>
                <div style="visibility: hidden;" class="main_desc">支付后可开发票</div>
            </div>
        </Modal>

        <!--    购买弹框    -->
        <myPay :subBizType="bagSelection" :payMoney="bagMoney" @fatherModal="fatherModal" mywidth='766' myHeight="425" myTitleheight="50" v-if="shopState" />

        <!--    会员续费弹框    -->
        <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="myczPayFuc"/>

    </div>

</template>

<script>
    import {_findFuelList} from '@/api/index.js';
    import myPay from '@/views/vipClip/vip/lawcomponent/mypay';
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay'



    export default {
        name: "monitorBag",
        components:{
            myPay,
            myczPay
        },
        props: {

            bizType: {
                type: String,
                default: ''
            },

            subBizType: {
                type: String,
                default: ''
            }
        },
        created() {
            if(this.bizType!=''){
                this.findFuelList();
            }
            else{
                toast('初始化失败，请重试');
            }
        },
        data() {
            return {
                modalState: true, //模态框开关
                shopState:false, //支付开关
                myczPayState:false, //会员续费开关
                selectData: [], //选择服务列表
                bagSelection: '', //当前选中值
                bagMoney: '', //当前选中金额


            }
        },
        methods: {

            /**************获取加油包接口数据方法**************/
            findFuelList() {
                let bizType = this.bizType;
                let subBizType = this.subBizType;
                if(subBizType == '01' || subBizType == '02' || subBizType == '03' | subBizType == '13'){
                    subBizType = '';
                }
                let resData = `?bizType=${bizType}&subBizType=${subBizType}`
                _findFuelList(resData).then(res => {
                    if (res.code == 200) {
                        let result = res.result;
                        let code = result[0].code;
                        this.selectData = result;
                        this.bagSelection = code;
                        this.setNowData(code);
                    } else {
                        toast('获取列表失败，请重试');
                    }
                }, (err) => {
                    toast('获取列表失败，请重试');
                    console.log(err);
                })
            },

            /**************设置模态框显示数据方法**************/
            setNowData(code) {
                let selectData = this.selectData;
                for (let i = 0; i < selectData.length; i++) {
                    let nowItem = selectData[i];
                    if (nowItem.code == code) {
                        this.bagMoney = nowItem.value;
                        break;
                    }
                }
            },


            /**************用户点击模态框取消事件**************/
            clickCancel(value){
                this.$emit("monitorBagFather");
            },

            /**************开通点击事件**************/
            OpeningBtn(){
                this.modalState = false;
                this.shopState = true;
            },

            /**************会员续费点击事件**************/
            renewBtn(){
                // this.modalState = false;
                // this.myczPayState = true;
              this.$emit("monitorBagFather");
              const routeData = this.$router.resolve({
                path: '/huiyuan.html' // 保持你的目标路由路径不变
              });
              // 2. 调用 window.open() 新打开标签页
              window.open(routeData.href, '_blank');
            },

            /**************接收购买子组件的传值，并关闭子组件**************/
            fatherModal(){
                this.clickCancel();
            },

            /**************接收会员续费子组件的传值，并关闭子组件**************/
            myczPayFuc(e){
                this.myczPayState = false;
                this.clickCancel();
            }


        }
    }
</script>

<style scoped lang="less">
    /deep/ .ivu-modal-header {
        padding: 20px 30px;
        border-bottom: 1px solid #ECECEC;
    }

    .monitor_bag .header_group {
        color: #323232;
    }

    .header_group .header_title {
        color: #323232;
        font-size: 16px;
        line-height: 22px;
        font-weight: 400;
    }

    .header_group .header_desc {
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
        padding-top: 6px;
    }

    .monitor_bag .monitor_bag_main {
        text-align: center;
        color: #323232;
        font-size: 14px;

        .main_title {
            font-weight: 400;
            font-size: 14px;
            padding-top: 30px;
        }

        .main_money {
            line-height: 25px;
            font-size: 18px;
            padding-top: 14px;
        }

        .main_btn_group{
            padding-top: 66px;
        }

        .main_btn_group .main_btn {
            width: 150px;
            height: 37px;
            line-height: 37px;
            background: #FFD800;
            border-radius: 21px;
            margin: 0 auto 20px;
            color: #4E4E4E;
            cursor: pointer;
        }

        .main_btn:last-child{
            margin-bottom: 0;
        }



        .main_desc {
            font-size: 12px;
            padding: 10px 0 15px;
        }
    }

    .monitor_bag_select {
        width: 252px;
        margin-top: 10px;
    }

    /deep/ .monitor_bag_select.ivu-select-single .ivu-select-selection {
        height: 46px;
    }

    /deep/ .monitor_bag_select.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .monitor_bag_select.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 46px;
        line-height: 46px;
        text-align: left;
        padding-left: 24px;
    }

    /deep/ .monitor_bag_select.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 46px;
        line-height: 46px;
        color: #323232;
        font-size: 14px;
        text-align: left;
        padding-left: 24px;

    }
</style>
